import { Model } from './shared/models/model';

export class PermissionModel extends Model {
    name: string;
    label: string;
}
